import { Injectable } from '@angular/core';
import { IToastConfig, ToastService } from 'snl-complib';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor(
    private toastService: ToastService,
  ){}
  openToast(type: any, message: any) {
    const toastConfig: IToastConfig = {
      type: type, //'Information' | 'Warning' | 'Success' | 'Error';
      message: message,
      addTitle: true,
      title: type,
      addProgressBar: true,
      timeout: 10000,
      position: 'bottom-right', //'top-right' | 'bottom-right' | 'top-left' | 'bottom-left' | 'top-center' | 'bottom-center'
      multiAlerts: true
    };
    this.toastService.open(toastConfig);
  }

}
